import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { PaymentMerchantSort, PaymentMerchantUpdateSortSequence } from "src/app/core/models/payment-acquirer-model";
import { PaymentMerchantReferenceService } from "src/app/core/services/system-services/payment-merchant-reference.service";

@Injectable({
    providedIn: 'root'
})
export class PaymentMerchantSortService {

    private _paymentMerchants$ = new BehaviorSubject<PaymentMerchantSort[]>([])
    private _callSort$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()
    private _updateSort$ = new Subject()
    private _paymentAcquirerCode: string;
    private _paymentAcquirerName$ = new BehaviorSubject<string>(null)

    get paymentMerchants$() {
        return this._paymentMerchants$.asObservable()
    }
    get callSort$() {
        return this._callSort$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }
    get updateSort$() {
        return this._updateSort$.asObservable()
    }
    get paymentAcquirerName$() {
        return this._paymentAcquirerName$.asObservable()
    }

    constructor(private paymentMerchantReference: PaymentMerchantReferenceService
    ) {
    }

    getPaymentMerchantsSort(): Observable<PaymentMerchantSort[]> {
        if (this._paymentAcquirerCode) {
            return this.paymentMerchantReference.getSort(this._paymentAcquirerCode)
                .pipe(
                    tap(response => this._paymentMerchants$.next(response))
                )
        }
    }

    updateSortSequence(items: PaymentMerchantUpdateSortSequence[]): Observable<never> {
        return this.paymentMerchantReference.updateSortSequence(items)
    }

    clearSort() {
        this._paymentMerchants$.next([])
    }
    callSort(paymentAcquirerCode: string, paymentAcquirerName: string) {
        this._paymentAcquirerCode = paymentAcquirerCode;
        this._paymentAcquirerName$.next(paymentAcquirerName);
        this._callSort$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }
    updateSort() {
        this._updateSort$.next()
    }
}
